import { authorizeAxios, deauthorizeAxios } from '@/api/axios'
import axiosApi from '@/api/v1/index'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('El-Client-Auth-Token') || '',
    refreshToken: localStorage.getItem('EL-Refresh-Token') || '',
    user: JSON.parse(localStorage.getItem('El-Client-User')) || null,
    logoutRoute: null,
  },
  mutations: {
    SET_USER_DATA(state, { id, login, profile }) {
      const userData = { id, login, ...profile }
      state.user = userData
      localStorage.setItem('El-Client-User', JSON.stringify(userData))
    },

    SET_TOKEN(state, { token, refreshToken }) {
      state.token = token
      localStorage.setItem('El-Client-Auth-Token', token)
      localStorage.setItem('EL-Refresh-Token', refreshToken)
    },

    CLEAR_SESSION_DATA(state) {
      state.token = ''
      state.user = {}
      localStorage.removeItem('El-Client-Auth-Token')
      localStorage.removeItem('EL-Refresh-Token')
      localStorage.removeItem('El-Client-User')
      localStorage.clear()
    },

    SET_LOGOUT_ROUTE(state, path) {
      state.logoutRoute = path
    },
  },
  actions: {
    login({ state, commit, dispatch }, userCredentials) {
      dispatch('core/setLoading', true, { root: true })

      axiosApi
        .login(userCredentials)
        .then(resp => {
          commit('SET_TOKEN', resp.data)
          commit('SET_USER_DATA', resp.data.user)
          authorizeAxios(resp.data)
          dispatch('core/initApp', null, { root: true }).then(() => {
            if (state.logoutRoute) {
              router.push({ name: state.logoutRoute })
              commit('SET_LOGOUT_ROUTE', null)
            } else {
              router.push({ name: 'clientOrders' })
            }
          })
        })
        .catch(() => {
          commit('CLEAR_SESSION_DATA')
        })
        .finally(() => {
          dispatch('core/setLoading', false, { root: true })
        })
    },

    changeLogoutRoute({ commit }, path) {
      commit('SET_LOGOUT_ROUTE', path)
    },

    resetPassword({ commit, dispatch }, password) {
      axiosApi.resetPassword(password).then(res => {
        commit('SET_TOKEN', res.data)
        authorizeAxios(res.data)
        dispatch('authClient/resetPassword')
          .then(() => {
            router.push({ name: 'login' })
          })
          .catch(() => {
            commit('CLEAR_SESSION_DATA')
          })
      })
    },

    logout({ commit, dispatch }) {
      axiosApi.logout().then(() => {
        commit('CLEAR_SESSION_DATA')
        deauthorizeAxios()
        router.push({ name: 'login' })
      })
    },
  },
  getters: {
    isLoggedIn(state) {
      return !!state.token
    },
    getFullName(state) {
      const { firstName, lastName } = state.user || {}
      return `${firstName} ${lastName}`
    },
    getInitials(state) {
      const { firstName, lastName } = state.user || {}
      return `${firstName ? firstName[0] : ''}${lastName ? lastName[0] : ''}`
    },
  },
}
